import { AppState } from "@store";
import * as React from "react";
import { connect, Dispatch } from "react-redux";
import "./MobilePage.css";
import { SvgIcon } from "@components";
import { AAdello, Logo } from "@icons";

export interface MobilePageComponentProps {}

export interface MobilePageComponentState {
    loginUrl: string;
}

export class MobilePageComponent extends React.Component<MobilePageComponentProps, MobilePageComponentState> {
    constructor(props: MobilePageComponentProps) {
        super(props);
    }

    render() {
        return (
            <div className="mobile-page-wrapper">
                <aside className="mobile-page_aside-block">
                    <SvgIcon className="mobile-page_logo" svg={AAdello} />
                </aside>
                <header className="mobile-page_header">
                    <SvgIcon className="mobile-page_header_logo" svg={Logo} />
                </header>
                <main className="mobile-page_main-block">
                    <h2 className="mobile-page_main-title">
                        Sorry, we don't support mobile devices on website!
                        <br /> Please login with our mobile app
                    </h2>
                </main>
            </div>
        );
    }
}

export interface MobilePageProps {}

export const MobilePage = connect(
    (state: AppState, ownProps: MobilePageProps) => ({}),
    (dispatch: Dispatch, ownProps: MobilePageProps) => ({})
)(MobilePageComponent);
